import { computed, inject, Injectable, signal } from '@angular/core';
// import { CheckPersonAML, CheckPersonAMLResponse, CreateOrUpdateContrahentReq, ICreateOrUpdateContrahentRes } from '../utils/models';
import { ApiService } from 'src/app/core/api.service';
import { Observable } from 'rxjs';

export type ScreenType ='desktop'|'mobile';
export interface IScreenType {
  desktop:boolean,
  mobile:boolean
}

const basePath: string = '/PersonalInfo';


@Injectable({
  providedIn: 'root'
})

export class SharedService {

  private readonly apiService = inject(ApiService);

  constructor() { }


  private screenType =signal<ScreenType>('desktop');
  screenTypeState =computed(this.screenType);


  updateScreenType(screenType:ScreenType){
    this.screenType.set(screenType)
  }


  
}
